import React from 'react';
import css from '../AddToCartButton/AddToCartButton.module.css';
import { Button } from '..';

const AddToCartButton = props => {
  const {
    listing,
    count,
    incrementCart,
    isListingPage,
    buttonLabel,
    cartLabel,
    isBooking = false,
    showProductOrderForm = true,
    isOwnListing = false,
  } = props;

  if (isBooking || !showProductOrderForm) {
    return null;
  }

  const increaseCount = () => incrementCart(1);
  const decreaseCount = () => incrementCart(-1);
  const removeCount = () => incrementCart(count);
  const currentStock = listing?.currentStock?.attributes.quantity;
  const isMaxItems = currentStock <= count;
  const isMinItems= count==1;

    return (
      <div>
        {isListingPage && (cartLabel)}
        <div className={css.buttonContainer}>
          <Button className={css.smallButton} disabled={isMinItems} onClick={decreaseCount}>
            -
          </Button>
          <span className={css.quantityCount}>Qty: {count}</span>
          <Button className={css.smallButton} disabled={isMaxItems} onClick={increaseCount}>
            +
          </Button>
          {currentStock !== undefined && (
            <span className={css.stockAvailable}>
              {currentStock} available
            </span>
          )}
        </div>
      </div>
    );
  }
// };

AddToCartButton.defaultProps = {
  isListingPage: false,
};

export default AddToCartButton;
